/** Function to extract the host from channel Id
    Existing logging infra doesn't allow email addresses
    to be logged since they are PII.
 */
export function extractHostFromChannelId(channelId: string) {
    return channelId.split('@')[0];
}
